import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import ViewportMeta from './ViewportMeta';
import { getShiftTheme, setShiftTheme } from '../pages/shift/ShiftChrome';
import { useShiftI18n } from '../i18n/ShiftI18nContext';
import '../pages/shift/shift.css';

// 手機外殼；各頁自行渲染 topbar 與 scroll 內容
export default function ShiftLayout() {
  const { lang, t } = useShiftI18n();
  useEffect(() => {
    const prev = document.title;
    document.title = t('layout.docTitle');
    setShiftTheme(getShiftTheme());
    return () => { document.title = prev; };
  }, [t, lang]);
  return (
    <div className="shift-root" data-theme={getShiftTheme()} lang={lang} translate="yes">
      <ViewportMeta />
      <div className="shift-phone">
        <Outlet />
      </div>
    </div>
  );
}
